import React, { useEffect, useState, useMemo, Fragment } from "react";
import DashboardService from "../../services/pbumku/DashboardService";
import { Row, Col, Dropdown, Alert } from "react-bootstrap";
import Card from "../../components/Card";
import SKPChart from "./components/skp-chart";
import HACCPChart2 from './components/haccp-chart-2';
import PrimerChart2 from './components/primer-chart-2';

const DashboardGraphPBUMKU = () => {
    const [rekap, setRekap] = useState([]);
    const [provinsi, setProvinsi] = useState([]);
    const [frequensi, setFrequensi] = useState([]);
    const [haccp, setHaccp] = useState([]);
    const [rekapPermohonan, setRekapPermohonan] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const DashService = useMemo(() => new DashboardService(), []);
    const [isTrader, setIsTrader] = useState(false);
    const today = new Date();
    const tahunBerjalan = today.getFullYear();
    const [jmlHaccp, setJmlHaccp] = useState({ A: 0, B: 0, C: 0, JUMLAH: 0 });
    const [rekapSKP, setRekapSKP] = useState([]);
    const [totalPermohonanSKP, setTotalPermohonanSKP] = useState(0);
    const [totalTerbitSKP, setTotalTerbitSKP] = useState(0);
    const [rekapHACCPGrade, setRekapHACCPGrade] = useState([]);
    const [limitHACCP, setLimitHACCP] = useState(5);
    const [limitPrimer, setLimitPrimer] = useState(8);
    const [limitSKP, setLimitSKP] = useState(5);

    // inisialisasi state untuk tahun
    const [thnAwal, setThnAwal] = useState(`${tahunBerjalan}-01-01`);
    const [thnAkhir, setThnAkhir] = useState(`${tahunBerjalan}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`);
    const [thnIni, setThnIni] = useState(tahunBerjalan);


    // variabel untuk x axis
    const [xAxis, setXAxis] = useState(2);

    // variabel baca satker Pusat
    const [kdUPT, setKdUPT] = useState("00.1");

    const formatDate = (date, isEndOfDay = false) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const time = isEndOfDay ? "23:59:59" : "00:00:00";
        return `${yyyy}-${mm}-${dd} ${time}`;
    };

    const getRekapPBUMKU = async () => {
        try {
            const res = await DashService.getRekapPBUMKU(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true)
            );
            setRekap(res.data);
        } catch (err) {
            console.error("❌ Error getRekapPBUMKU:", err);
        }
    };

    const getProvinsiIzin = async () => {
        try {
            const res = await DashService.getPropinsiIzinRekap(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true),
                limitPrimer
            );
            setProvinsi(res.data);
        } catch (err) {
            console.error("❌ Error getProvinsiIzin:", err);
        }
    };

    const getFrekuensi = async () => {
        try {
            const res = xAxis === 1
                ? await DashService.getFrequensi(kdUPT, formatDate(new Date(thnAwal)), formatDate(new Date(thnAkhir), true))
                : await DashService.getFrequensiBulan(kdUPT, formatDate(new Date(thnAwal)), formatDate(new Date(thnAkhir), true));
            setFrequensi(res.data);
        } catch (err) {
            console.error("❌ Error getFrekuensi:", err);
        }
    };

    const getHaccp = async () => {
        try {
            const res = await DashService.getHACCPBulan(thnIni);
            setHaccp(res.data);
        } catch (err) {
            console.error("❌ Error getHACCP:", err);
        }
    };

    const getRekapPermohonan = async () => {
        try {
            const res = await DashService.getRekapPermohonan(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true)
            );
            setRekapPermohonan(res.data);
        } catch (err) {
            console.error("❌ Error getRekapPermohonan:", err);
        }
    };

    const getJumlahHACCP = async () => {
        try {
            const res = await DashService.getJumlahHACCP(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true)
            );
            setJmlHaccp(res.data);
        } catch (err) {
            console.error("❌ Error getJumlahHACCP:", err);
        }
    };

    const getSKPPerPropinsi = async () => {
        try {
            const res = await DashService.getSKPPerPropinsi(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true),
                limitSKP
            );
            setRekapSKP(res.data);
        } catch (err) {
            console.error("❌ Error getSKPPerPropinsi:", err);
        }
    };

    const getTotalPermohonanSKP = async () => {
        try {
            const res = await DashService.getJumlahTotalPermohonanSKP(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true)
            );
            setTotalPermohonanSKP(res.data.totalPermohonan);
        } catch (err) {
            console.error("❌ Error getJumlahTotalPermohonanSKP:", err);
        }
    };

    const getTotalTerbitSKP = async () => {
        try {
            const res = await DashService.getJumlahTotalSKPTerbit(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true)
            );
            setTotalTerbitSKP(res.data.totalSKPTerbit);
        } catch (err) {
            console.error("❌ Error getJumlahTotalSKPTerbit:", err);
        }
    };

    const getHACCPPerPropinsiPerGrade = async () => {
        try {
            const response = await DashService.getHACCPPerPropinsiPerGrade(
                formatDate(new Date(thnAwal)),
                formatDate(new Date(thnAkhir), true),
                limitHACCP
            );
            setRekapHACCPGrade(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getRole = () => {
        const roleaturan = localStorage.getItem("role");
        const includedTrader = new Set(["4", "5"]);
        const isIncluded = includedTrader.has(roleaturan);
        setIsTrader(isIncluded);
        if (isIncluded) console.log("✅ Ini trader");
    };

    useEffect(() => {
        getRole();
        getRekapPBUMKU();
        getProvinsiIzin();
        // getFrekuensi();
        getHaccp();
        getRekapPermohonan();
        getJumlahHACCP();
        getSKPPerPropinsi();
        getTotalPermohonanSKP();
        getTotalTerbitSKP();
        getHACCPPerPropinsiPerGrade();
    }, []);

    useEffect(() => {
        getHACCPPerPropinsiPerGrade();
    }, [limitHACCP, thnAwal, thnAkhir]);

    useEffect(() => {
        getSKPPerPropinsi();
    }, [limitSKP, thnAwal, thnAkhir]);

    useEffect(() => {
        getProvinsiIzin();
    }, [limitPrimer, thnAwal, thnAkhir]);

    const statusPermohonan = [
        { status: "Permohonan", jumlah: parseInt(rekap?.Permohonan || 0) },
        { status: "Persyaratan Telah Diverifikasi", jumlah: parseInt(rekap?.PersyaratanTelahdiverifikasi || 0) },
        { status: "Permohonan Perlu Diperbaiki", jumlah: parseInt(rekap?.PermohonanPerluDiperbaiki || 0) },
        { status: "Terbit Sertifikat", jumlah: parseInt(rekap?.TerbitSertifikat || 0) },
        { status: "Ditolak", jumlah: parseInt(rekap?.Ditolak || 0) },
        { status: "Persyaratan Ditolak Lanjut ke Tahap Persetujuan KL", jumlah: parseInt(rekap?.PersyaratanDitolakLanjutkeTahapPersetujuanKL || 0) }
    ];

    const totalJumlah = rekap?.totalJumlah || 0;
    statusPermohonan.forEach(item => {
        item.prosentase = totalJumlah ? ((item.jumlah / totalJumlah) * 100).toFixed(2) : 0;
    });

    useEffect(() => {
        // console.log("✅ Data provinsi:", provinsi);
    }, [provinsi]);

    const handleSelectGrade = (eventKey) => {
        setLimitHACCP(eventKey === "all" ? null : parseInt(eventKey));
    };

    const handleSelectSKP = (eventKey) => {
        setLimitSKP(eventKey === "all" ? null : parseInt(eventKey));
    };

    const handleSelectPrimer = (eventKey) => {
        setLimitPrimer(eventKey === "all" ? null : parseInt(eventKey));
    };

    return (
        <Fragment>
            {!isTrader ? (
                <Fragment>
                    <Row className="align-items-stretch gx-3 gy-0" style={{ marginTop: "-15px" }}>
                        <Col xs="12" md="12" className="mb-2">
                            <Row className="align-items-center" style={{ marginTop: "-30px" }}>
                                <Col lg={6} md={12} className="mb-lg-0">
                                    <h4 className="text-white">SERTIFIKASI MUTU PRIMER</h4>
                                </Col>
                                <Col lg={6} md={12} className="mb-lg-0">
                                    <h4 className="text-white">SERTIFIKASI MUTU PASCA PANEN</h4>
                                </Col>
                            </Row>
                        </Col>
                        {/* Bagian Grafik Per Provinsi */}
                        <Col xs="12" md="6">
                            <Card className="h-800 shadow-sm rounded-3 mb-3">
                                {/* <Card.Header className="d-flex justify-content-between align-items-center">
                                    <h6 className="card-title mb-0">JUMLAH SERTIFIKAT MUTU PRIMER PER PROPINSI</h6>
                                    <h6 className="text-primary mb-0">Tahun {thnIni}</h6>
                                </Card.Header> */}
                                <Card.Header className="d-flex flex-column gap-2">
                                    {/* Baris atas: Title kiri, Dropdown kanan */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0 fw-bold text-uppercase">
                                            Grafik SERTIFIKASI MUTU PRIMER PER PROVINSI Tahun {thnIni}
                                        </h6>
                                        <Dropdown onSelect={handleSelectPrimer}>
                                            <Dropdown.Toggle
                                                variant="outline-dark"
                                                size="sm"
                                                id="dropdown-limit"
                                                style={{
                                                    fontSize: "1rem",
                                                    padding: "6px 12px",
                                                    minWidth: "100px"
                                                }}
                                            >
                                                {limitPrimer ? `Top : ${limitPrimer}` : "Semua"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu
                                                align="end"
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    color: "#212529",
                                                    border: "1px solid #999",
                                                    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                                                    zIndex: 1050,
                                                    fontSize: "1rem",
                                                    minWidth: "130px",
                                                    padding: "8px 0",
                                                }}
                                            >
                                                <Dropdown.Item eventKey="all" style={{ padding: "8px 16px" }}>Semua</Dropdown.Item>
                                                <Dropdown.Item eventKey="8" style={{ padding: "8px 16px" }}>8</Dropdown.Item>
                                                <Dropdown.Item eventKey="10" style={{ padding: "8px 16px" }}>10</Dropdown.Item>
                                                <Dropdown.Item eventKey="15" style={{ padding: "8px 16px" }}>15</Dropdown.Item>
                                                <Dropdown.Item eventKey="20" style={{ padding: "8px 16px" }}>20</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </Card.Header>
                                <Card.Body className="py-2">
                                    {error && <Alert variant="danger">{error}</Alert>}

                                    {Array.isArray(provinsi.data) && provinsi.data.length > 0 ? (
                                        <>
                                            <PrimerChart2 rekapPrimer={provinsi.data} />

                                            <div className="d-flex flex-wrap gap-1 justify-content-center mt-3">
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#0071CE' }}
                                                >
                                                    Total CPIB
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.CPIB?.toLocaleString("id-ID")}
                                                </span>

                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#F7941E' }}
                                                >
                                                    Total CBIB
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.CBIB?.toLocaleString("id-ID")}
                                                </span>

                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#CF0F47' }}
                                                >
                                                    Total CPPIB
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.CPPIB?.toLocaleString("id-ID")}
                                                </span>

                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#004D40' }}
                                                >
                                                   Total CPOIB
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.CPOIB?.toLocaleString("id-ID")}
                                                </span>
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#4BA38A' }}
                                                >
                                                    Total CDOIB
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.CDOIB?.toLocaleString("id-ID")}
                                                </span>

                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#DC3C22' }}
                                                >
                                                    Total Jumlah Sertifkat Mutu Primer
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {provinsi.rekap.total?.toLocaleString("id-ID")}
                                                </span>
                                            </div>
                                        </>
                                    ) : (
                                        <p>📭 Data belum tersedia.</p>
                                    )}
                                </Card.Body>

                            </Card>
                            {/* 2 Card Permohoanan dan Terbit Sertifikat */}
                            {/* <Row>
                                <Col md="6" className="mb-2">
                                    <Card className="bg-soft-warning">
                                        <Card.Body className="p-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="bg-soft-warning rounded p-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22px"
                                                        height="22px"
                                                        viewBox="0 0 22 22"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z"
                                                            clipRule="evenodd"
                                                        />
                                                    </svg>
                                                </div>
                                                <div className="text-end">
                                                    <h5 className="counter">
                                                        {typeof rekapPermohonan?.totalJumlah === "number" && !isNaN(rekapPermohonan.totalJumlah) ? (
                                                            <CountUp start={rekapPermohonan.totalJumlah - 50} end={rekapPermohonan.totalJumlah} duration={3} />
                                                        ) : (
                                                            <span>0</span> // fallback agar tidak error
                                                        )}
                                                    </h5>
                                                    Total Permohonan Sertifikat Mutu Primer
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md="6" className="mb-2">
                                    <Card className="bg-soft-info">
                                        <Card.Body className="p-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="bg-soft-info rounded p-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22px"
                                                        height="22px"
                                                        viewBox="0 0 22 22"
                                                        fill="currentColor"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z"
                                                            clipRule="evenodd"
                                                        />
                                                    </svg>
                                                </div>
                                                <div className="text-end">
                                                    <h5 className="counter">
                                                        {typeof rekapPermohonan?.TerbitSertifikat === "number" && !isNaN(rekapPermohonan.TerbitSertifikat) ? (
                                                            <CountUp start={rekap.TerbitSertifikat - 50} end={rekap.TerbitSertifikat} duration={3} />
                                                        ) : (
                                                            <span>0</span> // fallback agar tidak error
                                                        )}
                                                    </h5>
                                                    Total Sertifikat Mutu Primer yang Terbit
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row> */}
                        </Col>

                        {/* Bagian Pusat Pasca Panen */}
                        <Col xs="12" md="6">
                            <div className="card mb-3">
                                <div className="card-header">
                                    {/* <div className="flex-wrap card-header d-flex justify-content-between"> */}
                                    {/* <div className="header-title ">
                                        <h6 className="fw-bold">TOP 10 JUMALAH SKP PER PROPINSI</h6>
                                    </div>
                                    <div className="header-title ">
                                        <h6 className="text-primary mb-0">Tahun {thnIni}</h6>
                                    </div> */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0 fw-bold text-uppercase">
                                            Grafik Sertifikasi SKP PER PROVINSI Tahun {thnIni}
                                        </h6>
                                        <Dropdown onSelect={handleSelectSKP}>
                                            <Dropdown.Toggle
                                                variant="outline-dark"
                                                size="sm"
                                                id="dropdown-limit"
                                                style={{
                                                    fontSize: "1rem",
                                                    padding: "6px 12px",
                                                    minWidth: "100px" 
                                                }}
                                            >
                                                {limitSKP ? `Top : ${limitSKP}` : "Semua"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu
                                                align="end"
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    color: "#212529",
                                                    border: "1px solid #999",
                                                    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                                                    zIndex: 1050,
                                                    fontSize: "1rem",
                                                    minWidth: "130px",
                                                    padding: "8px 0",
                                                }}
                                            >
                                                <Dropdown.Item eventKey="all" style={{ padding: "8px 16px" }}>Semua</Dropdown.Item>
                                                <Dropdown.Item eventKey="5" style={{ padding: "8px 16px" }}>5</Dropdown.Item>
                                                <Dropdown.Item eventKey="10" style={{ padding: "8px 16px" }}>10</Dropdown.Item>
                                                <Dropdown.Item eventKey="15" style={{ padding: "8px 16px" }}>15</Dropdown.Item>
                                                <Dropdown.Item eventKey="20" style={{ padding: "8px 16px" }}>20</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {Array.isArray(rekapSKP) && rekapSKP.length > 0 ? (
                                        <Fragment>
                                            <SKPChart rekapSKP={rekapSKP} />
                                            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center mt-1">
                                                {/* <div className="d-flex">
                                                    <span className="badge bg-primary px-2 py-1 fs-7 fw-semibold rounded-start">
                                                        Total Permohonan SKP
                                                    </span>
                                                    <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                        {totalPermohonanSKP?.toLocaleString("id-ID")}
                                                    </span>
                                                </div> */}

                                                <div className="d-flex">
                                                    <span className="badge bg-success px-2 py-1 fs-7 fw-semibold rounded-start">
                                                        Total SKP Terbit
                                                    </span>
                                                    <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                        {totalTerbitSKP?.toLocaleString("id-ID")}
                                                    </span>
                                                </div>
                                            </div>
                                        </Fragment>
                                    ) : (
                                        <p>Memuat data chart...</p>
                                    )}
                                </div>
                            </div>

                            <Row className="g-3">
                                <Col md={12}>
                                    <Card title="Card 2">
                                        <Card.Header className="d-flex flex-column gap-2">
                                            {/* Baris atas: Title kiri, Dropdown kanan */}
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6 className="mb-0 fw-bold text-uppercase">
                                                    Grafik Sertifikasi HACCP Per Provinsi Per Grade Tahun {thnIni}
                                                </h6>
                                                <Dropdown onSelect={handleSelectGrade}>
                                                    <Dropdown.Toggle
                                                        variant="outline-dark"
                                                        size="sm"
                                                        id="dropdown-limit"
                                                        style={{
                                                            fontSize: "1rem",
                                                            padding: "6px 12px",
                                                            minWidth: "100px"
                                                        }}
                                                    >
                                                        {limitHACCP ? `Top : ${limitHACCP}` : "Semua"}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        align="end"
                                                        style={{
                                                            backgroundColor: "#ffffff",
                                                            color: "#212529",
                                                            border: "1px solid #999",
                                                            boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                                                            zIndex: 1050,
                                                            fontSize: "1rem",
                                                            minWidth: "130px",
                                                            padding: "8px 0",
                                                        }}
                                                    >
                                                        <Dropdown.Item eventKey="all" style={{ padding: "8px 16px" }}>Semua</Dropdown.Item>
                                                        <Dropdown.Item eventKey="5" style={{ padding: "8px 16px" }}>5</Dropdown.Item>
                                                        <Dropdown.Item eventKey="10" style={{ padding: "8px 16px" }}>10</Dropdown.Item>
                                                        <Dropdown.Item eventKey="15" style={{ padding: "8px 16px" }}>15</Dropdown.Item>
                                                        <Dropdown.Item eventKey="20" style={{ padding: "8px 16px" }}>20</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </Card.Header>

                                        <Card.Body>
                                            {/* <HACCPChart2 rekapHACCPGrade={rekapHACCPGrade.data} /> */}
                                            <HACCPChart2 rekapHACCPGrade={rekapHACCPGrade?.data || []} />
                                            <div className="d-flex justify-content-center">
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#0071CE' }}
                                                >
                                                    Total Grade A
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {rekapHACCPGrade.totGradeA?.toLocaleString("id-ID")}
                                                </span>
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#F7941E' }}
                                                >
                                                    Total Grade B
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {rekapHACCPGrade.totGradeB?.toLocaleString("id-ID")}
                                                </span>
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#4BA38A' }}
                                                >
                                                    Total Grade C
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {rekapHACCPGrade.totGradeC?.toLocaleString("id-ID")}
                                                </span>
                                                <span
                                                    className="badge px-2 py-1 fs-7 fw-semibold rounded-start text-white"
                                                    style={{ backgroundColor: '#DC3C22' }}
                                                >
                                                    Total HACCP
                                                </span>
                                                <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                                                    {rekapHACCPGrade.totHACCP?.toLocaleString("id-ID")}
                                                </span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row >
                        </Col >
                    </Row >
                </Fragment >
            ) : (
                <Fragment>
                    <Row>
                        <Col md="12">
                            <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                                <div>
                                    <h1 className="text-white">SIAP MUTU</h1>
                                    <h3 className="text-light">
                                        Sistem Informasi Aplikasi Pelayanan Mutu{" "}
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Fragment>
            )
            }
        </Fragment >
    );
};

export default DashboardGraphPBUMKU;
